// extracted by mini-css-extract-plugin
export default {"application-form-container":"applicationForm_application-form-container__BdCQk","form":"applicationForm_form__YIJI5"};